module.exports = __webpack_public_path__ + "static/media/module_dynamic_link.c32b6214.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_dynamic_link.jpeg
// module id = ./src/resources/images/modules/module_dynamic_link.jpeg
// module chunks = 0